var portfolioPositionsTopFlop = {
	caption: {
		top: "Portfoliopositionen - Top Ergebnisse",
		flop: "Portfoliopositionen - Flop Ergebnisse",
		gainers: "Portfoliopositionen - Gewinner",
		losers: "Portfoliopositionen - Verlierer"
	},
	name: "Name",
	isin: "ISIN",
	lastPrice: "Letzter Kurs",
	lastPriceDateTime: "Datum/Zeit",
	unrealizedPerformance: "Nicht realisierte G u V in {currency}",
	unrealizedPerformanceRelative: "Nicht realisierte G u V %",
	unrealizedPerformanceBar: "Nicht realisierte G u V % von max",
	weight: "Gewicht %",
	marketValue: "Marktwert in {currency}",
	actions: "Aktionen",
	noPositions: "Keine Ergebnisse gefunden"
};
var de = {
	portfolioPositionsTopFlop: portfolioPositionsTopFlop
};

export { de as default, portfolioPositionsTopFlop };
